import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-41caba85"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "page"
};
const _hoisted_2 = {
  class: "top_menu"
};
const _hoisted_3 = {
  class: "icon-main"
};
const _hoisted_4 = ["src"];

const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 面具 ");

const _hoisted_6 = {
  class: "tuiguang-content"
};
const _hoisted_7 = ["src"];
const _hoisted_8 = {
  class: "right-main"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tuiguang-content-title"
}, "面具", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tuiguang-content-subtitle"
}, "声音互动交流社区，热门歌曲想唱就唱", -1));

const _hoisted_11 = {
  style: {
    "display": "flex",
    "align-items": "center",
    "margin-top": "60px"
  }
};
const _hoisted_12 = {
  style: {
    "margin-right": "40px"
  }
};

const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Android下载", -1));

const _hoisted_14 = [_hoisted_13];
const _hoisted_15 = {
  class: "beian"
};

const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 粤公网安备44010602013206号    网站备案/许可证号： ");

const _hoisted_17 = {
  class: "hide"
};

const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cus-title"
}, "公司介绍", -1));

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cus-text"
}, [/*#__PURE__*/_createTextVNode(" 广州颜如玉网络有限公司，是一家专注于移动互联网领域的产品研发公司，公司核心团队由字节和腾讯产品研发同学组成，具备优秀的产品设计、研发能力"), /*#__PURE__*/_createElementVNode("br"), /*#__PURE__*/_createTextVNode(" 颜如玉面具是我司打造的一款声音互动社区产品，用户可以在平台发布语音动态、翻唱，与不同用户进行声音互动，打造独特的语音互动新鲜体验 ")], -1));

const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "cus-title"
}, "联系我们", -1));

const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "cus-text"
}, "mianjukefu@163.com", -1));

const _hoisted_22 = [_hoisted_18, _hoisted_19, _hoisted_20, _hoisted_21];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: "content-main",
    style: _normalizeStyle({
      backgroundImage: 'url(' + $setup.bg + ')',
      backgroundSize: 'cover'
    })
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
    src: $setup.appIcon,
    class: "app-icon"
  }, null, 8, _hoisted_4), _hoisted_5]), _createElementVNode("span", {
    class: "content-us",
    onClick: _cache[0] || (_cache[0] = $event => $setup.show = true)
  }, "关于我们")]), _createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    src: $setup.phoneCtn,
    class: "left-phone-ctn"
  }, null, 8, _hoisted_7), _createElementVNode("div", _hoisted_8, [_hoisted_9, _hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("div", _hoisted_12, [_createElementVNode("div", {
    class: "down-btn down-pc",
    style: {
      "margin-top": "30px"
    },
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.downloadAndroid && $setup.downloadAndroid(...args))
  }, _hoisted_14)])])])])]), _createElementVNode("div", _hoisted_15, [_hoisted_16, _createElementVNode("span", {
    class: "beian-url",
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.openUrl && $setup.openUrl(...args))
  }, "粤ICP备2022113931号-4")])]), _withDirectives(_createElementVNode("div", _hoisted_17, null, 512), [[_vShow, $setup.show]]), _withDirectives(_createElementVNode("div", {
    class: "content-back",
    onClick: _cache[4] || (_cache[4] = $event => $setup.show = false)
  }, [_createElementVNode("div", {
    class: "cus-content",
    onClick: _cache[3] || (_cache[3] = $event => $setup.show = false)
  }, _hoisted_22)], 512), [[_vShow, $setup.show]])], 4);
}